import React from 'react';
export function VideosSection() {
  return <div className="space-y-8" data-id="element-1556">
      <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-200 space-y-6" data-id="element-1557">
        <h3 className="text-xl font-bold text-navy text-center" data-id="element-1558">
          Bodor Laser - 3000w, 6000w and 12000w Fiber Laser Cutting Comparison
        </h3>
        <div className="aspect-video w-full max-w-3xl mx-auto rounded-lg overflow-hidden shadow-md" data-id="element-1559">
          <iframe className="w-full h-full" src="https://www.youtube.com/embed/qnnTjMWWnqc?wmode=opaque" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen data-id="element-1560"></iframe>
        </div>
      </div>

      <div className="grid md:grid-cols-2 gap-8" data-id="element-1561">
        <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-200 space-y-6 flex flex-col" data-id="element-1562">
          <h3 className="text-xl font-bold text-navy text-center flex-grow" data-id="element-1563">
            Bodor Laser 40kW Fiber Laser
          </h3>
          <div className="aspect-video w-full rounded-lg overflow-hidden shadow-md" data-id="element-1564">
            <iframe className="w-full h-full" src="https://www.youtube.com/embed/tjLo3vzLHo8?wmode=opaque" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen data-id="element-1565"></iframe>
          </div>
        </div>

        <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-200 space-y-6 flex flex-col" data-id="element-1566">
          <h3 className="text-xl font-bold text-navy text-center flex-grow" data-id="element-1567">
            Bodor Laser 12kW Fiber Laser Cutting 12mm Carbon Steel
          </h3>
          <div className="aspect-video w-full rounded-lg overflow-hidden shadow-md" data-id="element-1568">
            <iframe className="w-full h-full" src="https://www.youtube.com/embed/rTUoPaF4wGg?wmode=opaque" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen data-id="element-1569"></iframe>
          </div>
        </div>
      </div>
    </div>;
}